<!-- This is all the data that goes into the NG content through transclusion.
  By adding app-shell, we throw all the content in app shell into ngcontent--->
<app-shell>
  <!-- the router outlet just gets updated dynamically based on the current route -->
  <router-outlet></router-outlet>
</app-shell>
